import { useState, useCallback } from 'react';
import { IEmpresas } from "../../interfaces/IEmpresas";
import Swal from 'sweetalert2';
import ReactS3Client from 'react-aws-s3-typescript';
import { configBucket } from '../../utils/S3Utils';
import EmpresasService from '../../services/EmpresasService';
/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

const tiposAnexos = {
    "CADASTRO_CLIENTE_FORNECEDOR": 1
}

function AnexosModal({ empresa, abaSelecionada }: { empresa: IEmpresas, abaSelecionada: string }) {
    const { t } = useTranslation();
    const [loadingFile, setLoadingFile] = useState<boolean>(false);
    const [tipoAnexo, setTipoAnexo] = useState<number>(0);
    const [nomeClienteFornecedorField, setNomeClienteFornecedorField] = useState<string>('A');
    const [linhaInicial, setLinhaInicial] = useState<string>('1');

    const sendClienteFornecedorAnexo = useCallback((url: string) => {
        if (!linhaInicial || !nomeClienteFornecedorField) {
            Swal.fire({
                text: t('Por favor preencha os campos de configuração do arquivo excel.'),
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });

            return;
        }

        setLoadingFile(true);

        EmpresasService.enviarArquivoCadastroClienteFornecedor(empresa.id, url, linhaInicial, nomeClienteFornecedorField).then(() => {
            Swal.fire({
                text: t('Arquivo processado e clientes/fornecedores cadastrados com sucesso.'),
                timer: 4000,
                icon: 'success',
                showConfirmButton: false
            });
        }).catch(() => {
            Swal.fire({
                text: t('Ocorreu um erro ao processar o arquivo selecionado, por favor valide o arquivo e suas configurações.'),
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        });

        setLoadingFile(false);
    }, [linhaInicial, nomeClienteFornecedorField]);

    const onChangeFile = useCallback(async (e: any) => {
        if (e.target.files !== null && e.target.files.length > 0) {
            const file = e.target.files[0] as File;
            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file, `${empresa?.id}`);
            sendClienteFornecedorAnexo(res.location)
        }
    }, [tipoAnexo, sendClienteFornecedorAnexo]);


    return <>
        <div style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px', minHeight: '505px', display: abaSelecionada === '3' ? 'block' : 'none' }}>
            <div style={{ display: 'flex', paddingBottom: '30px' }}>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>{t("Tipos de Anexo:")} </label>
                            <select className="form-control" value={tipoAnexo} onChange={(e) => setTipoAnexo(parseInt(e.target.value))}>
                                <option value={0}>{t("Selecione um tipo")}</option>
                                <option value={tiposAnexos.CADASTRO_CLIENTE_FORNECEDOR}>{t("Cadastro Cliente/Fornecedor")}</option>
                            </select>
                        </div>
                    </div>

                    {tipoAnexo === tiposAnexos.CADASTRO_CLIENTE_FORNECEDOR && (
                        <>
                            <div className="col-md-4">
                                <label>{t("Campo Nome Cliente/Fornecedor")}</label>
                                <div className='form-group'>
                                    <input type='text' onChange={(e) => setNomeClienteFornecedorField(e.target.value)} value={nomeClienteFornecedorField} className='form-control' />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <label>{t("Campo Linha Inicial")}</label>
                                <div className='form-group'>
                                    <input type='number' onChange={(e) => setLinhaInicial(e.target.value.toString())} value={linhaInicial} className='form-control' />
                                </div>
                            </div>
                        </>
                    )}

                    {tipoAnexo > 0 && (
                        <div className='col-md-12 mt-2'>
                            {!loadingFile ? <input type='file' placeholder='Insira a imagem aqui' accept='image/png' onChange={(e) => onChangeFile(e)} /> : (
                                <div className="spinner-border text-success" role="status">
                                    <span className="sr-only">{t("Enviando arquivo...")}</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
};

export default AnexosModal;